import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'services/auth/auth.service';

@Injectable()
export class AdminAuthGuard implements CanActivate {
	constructor(private router: Router, private authService: AuthService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		let user = this.authService.currentUser;
		if (user && user.is_admin) return true;
		this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
		return false;
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/auth/admin-auth-guard.service.ts